export default __webpack_public_path__ + "static/media/payup.b83b16b5.jpg";